// pages/MapPage/MapPage.jsx
import React from 'react';
import MapContainer from './MapContainer';

const MapPage = () => {
  return <MapContainer />;
};

export default MapPage;
